<template>
  <Advisor />
</template>

<script>
import Advisor from "@/developing/views/pages/Advisor";

export default {
  components: {
    Advisor
  }
}
</script>
